import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedCustomerNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const newPatientFlowName = "newPatient";

/** Legacy flow name alias. Routes users with cached "newPatient" sessions to the no-confirmation experience. */
class NewPatientFlow extends Flow {
  static readonly flowName = newPatientFlowName;

  constructor(isCustomerPreQualified: boolean) {
    isCustomerPreQualified
      ? super(
          newPatientFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedCustomerNavigatorConfiguration
        )
      : super(
          newPatientFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NewPatientFlow;
